module.exports = __webpack_public_path__ + "img/mxd-white.470f218b.svg";